export default "__VITE_ASSET__BiYuUW4H__"